module.exports = __webpack_public_path__ + "static/zentralamerika-204c99cd2777c19aec31acb1ef406c4b.svg";